import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@devhop/ui";
import SignInForm from "../ui/SignInForm";

export function LoginPage() {
  return (
    <Card className="w-full border-border bg-card shadow-lg">
      <CardHeader className="space-y-1.5">
        <CardTitle className="font-bold font-heading text-foreground text-lg tracking-tight">
          ເຂົ້າລະບົບ
        </CardTitle>
        <CardDescription className="text-muted-foreground">
          ໃສ່ອີເມວ ແລະ ລະຫັດຜ່ານຂ້າງລຸ່ມນີ້ເພື່ອເຂົ້າໃຊ້ບັນຊີຂອງທ່ານ
        </CardDescription>
      </CardHeader>
      <CardContent>
        <SignInForm />
      </CardContent>
    </Card>
  );
}
